import {ContentState} from '../../store';

export const initialKPICardContentState: ContentState = {
  init: false,
  form: {
    source: '',
    source_uid: '',
    column: '',
    column_label: '',
    format: '#,##0.###',
    is_percentage: false,
    comparison: {
      show: false,
      type: 'NONE',
      format: '#,##0.###',
      is_percentage: false,
    },
    sparkline: {
      color: 'INDIGO',
      show: true,
    },
  },
  isPreview: false,
  tmpForm: {},
}
